import { img14, img15, img16, img17, img18 } from "../assets";

const Prize = ({ prizeRef }) => {
  return (
    <div
      ref={prizeRef}
      className="w-screen h-auto relative flex items-center justify-center flex-col "
    >
      <img
        className="object-fill absolute z-[-1] w-screen h-[100%]"
        src={img14}
        alt=""
      />
      <div className="text-[26px] sm:text-[28px] font-[700] text-[#ffffff] border-b-[6px] pb-[15px] w-fit border-[#FFFFFF] mb-[20px] mt-[32px] text-center">
        GIẢI THƯỞNG
      </div>
      <div className="w-[100%] flex flex-wrap gap-[20px] justify-center pb-[40px]">
        {/* <div className=""> */}
          <img className="w-[159px] h-[127px] sm:w-[183px] sm:h-[148px] lg:w-[261px] lg:h-[209px] border-[1px] border-white rounded-[20px]" src={img15} alt="" />
        {/* </div> */}
        <img className="w-[159px] h-[127px] sm:w-[183px] sm:h-[148px] lg:w-[261px] lg:h-[209px] border-[1px] border-white rounded-[20px]" src={img16} alt="" />
        <img className="w-[159px] h-[127px] sm:w-[183px] sm:h-[148px] lg:w-[261px] lg:h-[209px] border-[1px] border-white rounded-[20px]" src={img17} alt="" />
        <img className="w-[159px] h-[127px] sm:w-[183px] sm:h-[148px] lg:w-[261px] lg:h-[209px] border-[1px] border-white rounded-[20px]" src={img18} alt="" />

      </div>
    </div>
  );
};

export default Prize;
